var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.icons[(_vm.icon + "-" + _vm.type)],"fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }